/**
 * useGoalEventHandlers — Aggregates goal-related event handlers for the dashboard.
 */
import { Goal } from "@/types/todo";
import { useTodoHandlers } from "../goal-handlers/useTodoHandlers";
import { useSubtaskHandlers } from "../goal-handlers/useSubtaskHandlers";
import { useSubSubtaskHandlers } from "../goal-handlers/useSubSubtaskHandlers";
import { useTodoDateHandler } from "../goal-handlers/useTodoDateHandler";

export interface GoalOperations {
  addTodo: (params: { goalTitle: string; todoText: string; todoDueDate: string }) => Promise<any>;
  deleteTodo: (params: { goalTitle: string; todoId: string }) => Promise<any>;
  toggleTodo: (params: { goalTitle: string; todoId: string }) => Promise<any>;
  updateTodo: (params: { goalTitle: string; todoId: string; newText: string }) => Promise<any>;
  addSubtask: (params: { goalTitle: string; todoId: string; subtaskText: string }) => Promise<any>;
  deleteSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string }) => Promise<any>;
  toggleSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string }) => Promise<any>;
  updateSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string; newText: string }) => Promise<any>;
  addSubSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string; subSubtaskText: string }) => Promise<any>;
  deleteSubSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string; subSubtaskId: string }) => Promise<any>;
  toggleSubSubtask: (params: { goalTitle: string; todoId: string; subtaskId: string; subSubtaskId: string }) => Promise<any>;
  updateGoal: (updatedGoal: Goal) => Promise<any>;
  updateTodoDueDate: (params: { goalTitle: string; todoId: string; newDate: Date | string | null }) => Promise<any>;
}

export const useGoalEventHandlers = (operations: GoalOperations, goals: Goal[]) => {
  // Use the refactored handlers
  const todoHandlers = useTodoHandlers(operations);
  const subtaskHandlers = useSubtaskHandlers(operations);
  const subSubtaskHandlers = useSubSubtaskHandlers(operations);
  const todoDateHandler = useTodoDateHandler(goals);

  return {
    ...todoHandlers,
    ...subtaskHandlers,
    ...subSubtaskHandlers,
    handleUpdateDueDate: todoDateHandler.handleUpdateDueDate
  };
};
